import React from "react";
import ServiceRequestForm from "./ServiceRequestForm";

export default function CCTVServiceRequestForm() {
  return <ServiceRequestForm serviceType="CCTVService" title="CCTV" />;
}

